module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "bottom": "0 !important"
    }
  }, [_c('v-layout', {
    staticClass: "white footer-md",
    attrs: {
      "hidden-md-and-down": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../img/ICR_Logo2012_400x80.jpg")
    }
  }), _c('br')]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Powered by:")]), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "src": require("../../img/canSAR_logo_0913_alpha_500x326.png")
    }
  })]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": require("../../img/cruk_new_logo.jpg")
    }
  })]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "src": require("../../img/Wellcome_Trust_logo.png")
    }
  })]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "src": require("../../img/targetvalidationtoolkit2.png")
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "white footer-sm",
    attrs: {
      "hidden-lg-and-up": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "110%"
    },
    attrs: {
      "src": require("../../img/ICR_Logo2012_400x80.jpg")
    }
  }), _c('br')]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "600"
    }
  }, [_vm._v("Powered by:")]), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "src": require("../../img/canSAR_logo_0913_alpha_500x326.png")
    }
  })]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "src": require("../../img/cruk_new_logo.jpg")
    }
  })]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": require("../../img/Wellcome_Trust_logo.png")
    }
  })]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": require("../../img/targetvalidationtoolkit2.png")
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-010256d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prb-footer/PrbFooter.vue
// module id = 548
// module chunks = 1